module.exports = __webpack_public_path__ + "img/RV.63e24b7e.png";